'use strict';

import { view } from '@/functions';

const prefix = '/terminal-orders';

export default [
    {
        path: prefix,
        name: 'terminal-orders',
        meta: {
            title: 'Terminal orders',
            scopes: ['read_terminal_orders', 'write_terminal_orders']
        },
        component: () => view('terminal-orders/index'),
    },
    {
        path: `${prefix}/info`,
        name: 'terminal-orders-info',
        meta: {
            title: 'Terminal orders',
            scopes: ['read_terminal_orders', 'write_terminal_orders']
        },
        component: () => view('terminal-orders/info'),
    },
];
